"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Copyright (c) 2023 The xterm.js authors. All rights reserved.
 * @license MIT
 */
const inwasm_runtime_1 = require("inwasm-runtime");
const wasmQoiDecode = (0, inwasm_runtime_1.InWasm)(/*inwasm#459f9e1bfb80b1a8:rdef-start:"qoi_decode"*/{s:1,t:0,d:'AGFzbQEAAAABCgJgAABgA39/fwACDwEDZW52Bm1lbW9yeQIAAQMDAgABBwcBA2RlYwABCAEACu4EAgwAQQBBAEGAAvwLAAveBAEJf0EAQQBBgAL8CwAgAUEXTgRAIAAgAWpBCGshCkGACCEBIAJBAnRBgAhqIQsgAEEOaiEDQf8BIQZBACECA0AgA0EBaiEHIAMtAAAiCEE/cSEAAkACQCAIQcABcSIJRQRAIABBAnQiAC0AAyEGIAAtAAIhBCAALQABIQUgAC0AACECIAchAwwBCwJAIAhB/QFLDQAgCUHAAUcNACAFQQVsIAJBA2xqIARBB2xqIAZBC2xqQT9xQQJ0IgMgBDoAAiADIAU6AAEgAyACOgAAIANBA2ogBjoAAANAIAEgAjoAACABQQNqIAY6AAAgAUECaiAEOgAAIAFBAWogBToAACABQQRqIQEgAEUEQCAHIQMMBAsgAEEBayEAIAEgC0kNAAsgByEDDAILAn8CQAJAAkAgCEH+AWsOAgABAgsgAy0AAyEEIAMtAAIhBSADLQABIQIgA0EEagwCCyADKAIBIgJBGHYhBiACQRB2IQQgAkEIdiEFIANBBWoMAQsgCUGAAUcEQCAHIAlBwABHDQEaIAQgCEEDcWpBAmshBCACIABBBHZqQQJrIQIgBSAIQQJ2QQNxakECayEFIAcMAQsgBCAAQShrIgkgAy0AASIHQQ9xamohBCACIAdBBHYgCWpqIQIgACAFakEgayEFIANBAmoLIQMgBUEFbCACQQNsaiAEQQdsaiAGQQtsakE/cUECdCIAIAQ6AAIgACAFOgABIAAgAjoAACAAQQNqIAY6AAALIAEgBjoAAyABIAQ6AAIgASAFOgABIAEgAjoAACABQQRqIQELIAMgCkkNAAsLCw=='}/*inwasm#459f9e1bfb80b1a8:rdef-end:"qoi_decode"*/);
class QoiDecoder {
    constructor(keepSize) {
        this.keepSize = keepSize;
        this.width = 0;
        this.height = 0;
    }
    decode(d) {
        this.width = d[4] << 24 | d[5] << 16 | d[6] << 8 | d[7];
        this.height = d[8] << 24 | d[9] << 16 | d[10] << 8 | d[11];
        const pixels = this.width * this.height;
        const ib = pixels * 4;
        const dl = d.length;
        /**
         * byte/offset calculation:
         * To save some memory we dont reserve full memory for decoded + encoded,
         * but place encoded at the end of decoded plus 50% security distance
         * to avoid reads before writes positions:
         *
         * encoded < decoded (good compression)
         *    enc                                              ####################
         *    dec                 #######################################
         *                        ^                            ^
         *                        DST_P                        CHUNK_P
         *
         * encoded > decoded (degenerated compression, should not happen)
         *    enc                           ##############################
         *    dec                 ####################
         *                        ^         ^
         *                        DST_P     CHUNK_P
         *
         * There is still a chance for overlapping r/w positions in case the compressed
         * data has very different pixel progression, yet the 50% security distance
         * should deal with that, as QOI will bloat data by 25% at max (RGB -> OP byte + RGB).
         * Since we always assume RGBA at decoding stage, the possible bloat reduces to 20% at max.
         */
        const bytes = Math.max(ib, dl) + (Math.min(ib, dl) >> 1) + 4096;
        if (!this._inst) {
            this._mem = new WebAssembly.Memory({ initial: Math.ceil(bytes / 65536) });
            this._inst = wasmQoiDecode({ env: { memory: this._mem } });
        }
        else if (this._mem.buffer.byteLength < bytes) {
            this._mem.grow(Math.ceil((bytes - this._mem.buffer.byteLength) / 65536));
            this._d = null;
        }
        if (!this._d) {
            this._d = new Uint8Array(this._mem.buffer);
        }
        // put src data at the end of memory, also align to 256
        const chunkP = (this._mem.buffer.byteLength - dl) & ~0xFF;
        this._d.set(d, chunkP);
        this._inst.exports.dec(chunkP, dl, pixels);
        return this._d.subarray(1024 /* P8.DST_P */, 1024 /* P8.DST_P */ + ib);
    }
    release() {
        if (!this._inst)
            return;
        if (this._mem.buffer.byteLength > this.keepSize) {
            this._inst = this._d = this._mem = null;
        }
    }
}
exports.default = QoiDecoder;
//# sourceMappingURL=QoiDecoder.wasm.js.map